import React, {Component} from 'react'
import {connect} from 'react-redux'
import PageTitle from '../common/page-title/index'
import InlineCKEditor from '../common/editor/inline-editor'
import ArticleList from '../common/article/article-list'
import {getArticlesAboutIgnite} from '../../actions/about-ignite'
import {loadPageContent} from '../../actions/content';

class AboutIgnite extends Component {

  constructor(props) {
    super(props);

    this.pageSlug = 'about-ignite';
  }

  componentWillMount() {
    this.props.dispatch(getArticlesAboutIgnite());
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <div className="about-ignite container">
        <PageTitle>My Partnership</PageTitle>
        <InlineCKEditor
          identifier={`${this.pageSlug}_content_text`}
          onContentSaved={this.handleContentSaved}
          contents={this.props.contents[`${this.pageSlug}_content_text`]}
        />
        <ArticleList articles={this.props.articlesList}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    articlesList: state.aboutIgnite.aboutIgniteArticles,
    fetching:     state.aboutIgnite.fetching,
    fetched:      state.aboutIgnite.fetched,
    contents:     state.content.list
  };
};

export default connect(mapStateToProps)(AboutIgnite);



// WEBPACK FOOTER //
// ./src/components/about-ignite/index.jsx